<motif-theme [variant]="theme"></motif-theme>
<div class="container">
  <app-header
    *ngIf="loginDisplay && isLogin && loginSuccess && !isDashboard"
    class="gridArea"
    (menuToggled)="handleMenuToggle($event)"
    (themeSelected)="switchTheme($event)"
    (projectToggled)="handleProjectToggle($event)"
  ></app-header>
  <app-side-nav
    *ngIf="loginDisplay && isLogin && loginSuccess && hideMenu"
    class="navArea"
    [showMenu]="showMenu"
    [isDashboard]="isDashboard"
    [menuToggled]="isMenuToggled"
  ></app-side-nav>

  <app-progress-loader *ngIf="!loginDisplay && isLogin"></app-progress-loader>
  <app-data-loader *ngIf="loginDisplay && isLogin"></app-data-loader>
  <main [ngClass]="className" *ngIf="loginSuccess">  
    <router-outlet></router-outlet>
  </main>
</div>

<app-logout *ngIf="isLoggedOut"></app-logout>
